(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'campaigns'];

    function Controller($scope, $state, topBarService, businessUnit, campaigns) {

        topBarService.setTitleAndIcon('Survey | ' + businessUnit.TitleEN, 'fa fa-bullhorn');

        $scope.campaigns = campaigns;

        
        $scope.createCampaign = function () {
            $state.go('odd.surveyCampaigns.add');
         };

        $scope.goToCampaign = function (campaignID) {
            $state.go('odd.surveyCampaignEdit', { ODDCampaignID: campaignID });
         };
    }
})();